import React, { useRef, useEffect, useState } from "react";
const ChangeOverlayColorWidget = ({ view,layerIds}) => {
  const {parcels,parcelMaps,tractMaps,recordsOfSurvey }=layerIds  
  const [id, setid] = useState("");
    const changeOverlayColorWidgetDiv = useRef(null);
    const [overlaycolor, setoverlaycolor] = useState("#fca902");
    // const ocLandInsightsDictionaryCtx: any = useContext(OCLandInsightsContext);

    let mapId = view.map.portalItem.id;
 
  function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          R: parseInt(result[1], 16),
          G: parseInt(result[2], 16),
          B: parseInt(result[3], 16),
        }
      : null;
  }



  function colorSwitch(pixelData) {
    var pixelBlock, factor, minValue, maxValue;

    if (
      pixelData === null ||
      pixelData.pixelBlock === null ||
      pixelData.pixelBlock.pixels === null
    ) {
      return;
    }

    // The pixelBlock stores the values of all pixels visible in the view
    pixelBlock = pixelData.pixelBlock;

    // Get the min and max values of the data in the current view
    minValue = pixelBlock.statistics[0].minValue;
    maxValue = pixelBlock.statistics[0].maxValue;

    // The pixels visible in the view
    var pixels = pixelBlock.pixels;

    // The number of pixels in the pixelBlock
    var numPixels = pixelBlock.width * pixelBlock.height;

    // Calculate the factor by which to determine the red and blue
    // values in the colorized version of the layer
    factor = 255.0 / (maxValue - minValue);

    // Get the pixels containing temperature values in the only band of the data
    var tempBand = pixels[0];

    // Create empty arrays for each of the RGB bands to set on the pixelBlock
    var rBand = [];
    var gBand = [];
    var bBand = [];

    // Loop through all the pixels in the view
    for (let i = 0; i < numPixels; i++) {
      // Get the pixel value (the temperature) recorded at the pixel location
      var tempValue = tempBand[i];
      // Calculate the red value based on the factor

      // Sets a color between blue (coldest) and red (warmest) in each band
      rBand[i] = hexToRgb(overlaycolor).R;
      gBand[i] = hexToRgb(overlaycolor).G;
      bBand[i] = hexToRgb(overlaycolor).B;
    }

    // Set the new pixel values on the pixelBlock
    pixelData.pixelBlock.pixels = [rBand, gBand, bBand];
    pixelData.pixelBlock.pixelType = "U8"; // U8 is used for color
  }
  
  const updateColor = (e, id) => {
    setoverlaycolor(e.target.value);
    let imglayer = view.map.allLayers.find((layer) => layer.id === id);
    imglayer.pixelFilter = colorSwitch;
    imglayer.refresh();
    localStorage.setItem(`${id}-${mapId}`, e.target.value);
  };

  useEffect(() => {
    if (changeOverlayColorWidgetDiv.current) {
      //view.when(() => {
        //     view.ui.add(changeOverlayColorWidgetDiv.current,"top-right");
        const{title} = {
          title: view.popup.selectedFeature?.parentCustomParameters?.OCLandInsightsID || view.popup.selectedFeature.layer.customParameters?.OCLandInsightsID
        };
        switch (title) {
         
          case parcels:
              setid("legalLotImages");
                if(localStorage.getItem(`legalLotImages-${mapId}`)){
                    setoverlaycolor(localStorage.getItem(`legalLotImages-${mapId}`))
                };
            break;
          case parcelMaps:
              setid("ParcelMapsImages");
              if(localStorage.getItem(`ParcelMapsImages-${mapId}`)){
                setoverlaycolor(localStorage.getItem(`ParcelMapsImages-${mapId}`))
            };
            break;
          case recordsOfSurvey:
                setid("RecordsofSurveyImages");
                if(localStorage.getItem(`RecordsofSurveyImages-${mapId}`)){
                    setoverlaycolor(localStorage.getItem(`RecordsofSurveyImages-${mapId}`))
                };
            break;
          case tractMaps:
            setid("TractMapsImage");
            if(localStorage.getItem(`TractMapsImage-${mapId}`)){
                setoverlaycolor(localStorage.getItem(`TractMapsImage-${mapId}`))
            };
            break;
        }
        
      //});
    }
  }, []);

  let style = { display: "initial" };

  return (
    <div ref={changeOverlayColorWidgetDiv} style={style}>
      <div id="ColorPickerDiv" className="esri-widget">
      <input
          type="color"
          value={overlaycolor}
          onChange={(e) => updateColor(e, id)}
        />{" "}
        <b> Overlay Color Picker </b>
      </div>
      <br></br>
    </div>
  );
};

export default ChangeOverlayColorWidget;
